'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var hooks_useSanitizedUrl = require('./hooks/use-sanitized-url/index.js');
var iconLink = require('./icon-link-f19c861a.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["link", "wrapperRef", "children"];
var OwnUpUnderlineLink = function OwnUpUnderlineLink(_ref) {
  var link = _ref.link,
    _ref$wrapperRef = _ref.wrapperRef,
    wrapperRef = _ref$wrapperRef === void 0 ? undefined : _ref$wrapperRef,
    children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default['default'].createElement(iconLink.UnderlineLinkWrapper, _rollupPluginBabelHelpers._extends({
    href: hooks_useSanitizedUrl.useSanitizedUrl(link),
    underline: "none",
    ref: wrapperRef,
    tabIndex: 0
  }, props), children);
};

exports.OwnUpUnderlineLink = OwnUpUnderlineLink;
//# sourceMappingURL=underline-link-44641d89.js.map
